import { getTournamentState } from '@domain/Tournament/helpers/tournamentUtils';
export const extractTournamentAnalyticsData = (tournament, registrationEndingMinutes) => {
    var _a;
    return ({
        tournamentId: tournament.id,
        tournamentName: tournament.name,
        tournamentClass: tournament.tournament_class,
        brand: (_a = tournament.brand) === null || _a === void 0 ? void 0 : _a.name,
        entryFee: String(tournament.entry_fee),
        entryTypes: tournament.entry_types.map((entryType) => entryType.type).join(','),
        featured: String(tournament.featured),
        payoutCurrency: tournament.currencyType.abbreviation,
        tournamentState: getTournamentState(tournament, registrationEndingMinutes),
        game: tournament.score_template.game.game_key,
    });
};
// Indicative
// https://support.indicative.com/hc/en-us/articles/360004186991-JavaScript
const trackIndicative = (event) => {
    if (!window.Indicative) {
        return;
    }
    if (event.type === 'login' || event.type === 'sign_up' || event.type === 'authenticate_with_provider') {
        // If it's a login, we can set the ID for all future Indicative tracking calls
        if (event.userId) {
            window.Indicative.setUniqueID(event.userId);
        }
    }
    const { type, ...values } = event;
    window.Indicative.buildEvent(type, values);
};
export const setEventContext = (newContext) => {
    if (window.Indicative) {
        window.Indicative.addProperties(newContext);
    }
};
export const clearEventContext = () => {
    if (window.Indicative) {
        window.Indicative.clearProperties();
    }
};
/**
 * @deprecated - Migrating to useTrackEvent.ts for adobe analytics
 */
export const doTrackEvent = (event) => {
    trackIndicative(event);
};
export default doTrackEvent;
